import { EditorState } from '../types';

/**
 * Link가 활성화된 상태에서 linked track들의 ID를 가져옵니다.
 */
const getLinkedTrackIds = (
  _editorState: EditorState,
  trackId: string,
): Set<string> => new Set([trackId]);

/**
 * Magnetic 기능에서 사용할 링크된 트랙 ID들을 가져옵니다 (외부 export용)
 */
export const getLinkedTrackIdsForMagnetic = (
  editorState: EditorState,
  trackId: string,
): Set<string> => {
  return getLinkedTrackIds(editorState, trackId);
};

/**
 * 트랙의 magnetic 기능을 활성화합니다.
 * 메인 싱크와 독립적으로 이 트랙만 활성화합니다.
 */
export const enableMagnetic = (
  editorState: EditorState,
  trackId: string,
): EditorState => {
  const targetTrackIds = getLinkedTrackIds(editorState, trackId);
  let changed = false;

  const newTracks = editorState.undoableState.tracks.map((track) => {
    if (!targetTrackIds.has(track.id)) {
      return track;
    }

    if (track.magnetic) {
      return track;
    }

    changed = true;
    return { ...track, magnetic: true };
  });

  if (!changed) {
    return editorState;
  }

  return {
    ...editorState,
    undoableState: {
      ...editorState.undoableState,
      tracks: newTracks,
    },
  };
};

/**
 * 트랙의 magnetic 기능을 비활성화합니다.
 * 메인 싱크와 독립적으로 이 트랙만 비활성화합니다.
 */
export const disableMagnetic = (
  editorState: EditorState,
  trackId: string,
): EditorState => {
  const targetTrackIds = getLinkedTrackIds(editorState, trackId);
  let changed = false;

  const newTracks = editorState.undoableState.tracks.map((track) => {
    if (!targetTrackIds.has(track.id)) {
      return track;
    }

    if (!track.magnetic) {
      return track;
    }

    changed = true;
    return { ...track, magnetic: false };
  });

  if (!changed) {
    return editorState;
  }

  return {
    ...editorState,
    undoableState: {
      ...editorState.undoableState,
      tracks: newTracks,
    },
  };
};
